// Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction, 
// editing, distribution, as well as in the event of applications for industrial property rights.
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { InfoWindow } from "google-maps-react";

//@component
//InfoWindowEx
export default class InfoWindowEx extends Component {
	constructor(props) {
		super(props);
		this.infoWindowRef = React.createRef();
		this.contentElement = document.createElement(`div`);
	}
	//function for component update
	componentDidUpdate(prevProps) {
		if (this.props.children !== prevProps.children) {
			ReactDOM.render(
				React.Children.only(this.props.children),
				this.contentElement
			);
			this.infoWindowRef.current.infowindow.setContent(
				this.contentElement
			);
		}
	}

	render() {
		return <InfoWindow ref={this.infoWindowRef} {...this.props} />;
	}
}
